module.exports = __webpack_public_path__ + "img/89FF7E10.e9577817.jpg";